export function initFindARep(){
  function setup(){
    const pageRoot = document.querySelector('.far-page');
    if (!pageRoot) return; // only run on Find A Rep page

    const form = document.querySelector('.far-page__search-row');
    const input = form ? form.querySelector('input[name="searchTerm"]') : null;
    const resultsContainer = document.getElementById('repResultsContainer');
    const list = resultsContainer || document.getElementById('repResults');
    const empty = document.getElementById('resultsEmpty');
    const count = document.getElementById('resultsCount');
    const mapNotice = document.getElementById('mapNotice');
    const mapToggleBtn = document.querySelector('.far-page__map-toggle');
    const mapSection = document.getElementById('mapSection');

    if (mapToggleBtn && mapSection) {
      mapToggleBtn.addEventListener('click', () => {
        const isExpanded = mapToggleBtn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          mapSection.classList.add('is-collapsed');
          mapToggleBtn.setAttribute('aria-expanded', 'false');
          mapToggleBtn.textContent = 'Show Map';
        } else {
          mapSection.classList.remove('is-collapsed');
          mapToggleBtn.setAttribute('aria-expanded', 'true');
          mapToggleBtn.textContent = 'Hide Map';

          ensureMap();
        }
      });
    }

  let map, markers = [];
  let infoWindow;
  let repIndexToMarker = {};

  function getLatLngFromMarker(m){
    if (!m || !m.position) return null;
    
    const p = m.position;
    const lat = typeof p.lat === 'function' ? p.lat() : p.lat;
    const lng = typeof p.lng === 'function' ? p.lng() : p.lng;
    
    if (typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)) return { lat, lng };
    
    return null;
  }

  function recenterToAllMarkers(){
    if (!map) return;
      
    const currentMarkers = (markers || []).filter(m => !!getLatLngFromMarker(m));
    
    if (currentMarkers.length === 1){
      const pos = getLatLngFromMarker(currentMarkers[0]);
      if (pos) { map.setCenter(pos); map.setZoom(11); }
    } else if (currentMarkers.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      currentMarkers.forEach(m => { const pos = getLatLngFromMarker(m); if (pos) bounds.extend(pos); });
      map.fitBounds(bounds);
    }
  }

  function clearMarkers(){
    markers.forEach(m => { 
        try { 
            m.map = null; 
        } catch(e) { 
            console.error('Error clearing markers:', e); 
        } 
    });
    markers = []; repIndexToMarker = {};
  }

  function ensureMap(center){
    if (window.google && !map) {
      const mapEl = document.getElementById('map');
      if (!mapEl) return;

      // Use provided center or default to continental US centroid when none is provided
      const defaultCenter = (center && typeof center.lat === 'number' && typeof center.lng === 'number')
        ? center
        : { lat: 39.8283, lng: -98.5795 };

      const options = {
        center: defaultCenter,
        zoom: center ? 11 : 4,
        disableDefaultUI: false,
        zoomControl: true
      };
      
      if (mapId) options.mapId = mapId;
      
      map = new google.maps.Map(mapEl, options);
      infoWindow = new google.maps.InfoWindow();
      
      if (infoWindow && typeof infoWindow.addListener === 'function'){
        infoWindow.addListener('closeclick', function(){ recenterToAllMarkers(); });
      }
    } else if (!window.google) {
      const el = document.getElementById('map');
      if (el) el.style.display = 'none';
      if (mapNotice) mapNotice.style.display = 'block';
    }
  }

  // Opens a popup info window on the map for the given marker, optionally with the given content
  function openInfo(marker, content){
    if (!marker || !infoWindow) return;
    infoWindow.setContent(content || '');
    
    // Anchor to advanced marker element
    infoWindow.open({ map, anchor: marker });
  }

  // Adds a marker to the map with the given lat/lng coordinates and title, used for both search center and reps
  function addMarker(lat, lng, title, options){
    if (!window.google || !map) return null;
    
    const opts = options || {};

    // Build a custom pin with Mannington color #595653 for reps by default
    let pinContent = undefined;
    try {
      if (!opts.useDefault && google?.maps?.marker?.PinElement) {
        pinContent = new google.maps.marker.PinElement({
          background: '#595653',
          borderColor: '#3f3d3b',
          glyphColor: '#ffffff',
        });
      }
    } catch(e) {
        console.error('Error creating custom marker:', e);
    }

    const marker = new google.maps.marker.AdvancedMarkerElement({
      map: map,
      position: { lat: lat, lng: lng },
      title: title || '',
      content: (pinContent && pinContent.element) ? pinContent.element : undefined
    });
    if (!infoWindow) {
      infoWindow = new google.maps.InfoWindow();
      if (infoWindow && typeof infoWindow.addListener === 'function'){
        infoWindow.addListener('closeclick', function(){ recenterToAllMarkers(); });
      }
    }
    marker.addListener('click', () => openInfo(marker, title || ''));
    markers.push(marker);
    return marker;
  }
  
  if (!input) return;

  // Ensure URL reflects current search term on every search execution
  function updateUrlWithSearchTerm(term){
    try {
      const url = new URL(window.location.href);
      if (term) {
        url.searchParams.set('searchTerm', term);
      } else {
        url.searchParams.delete('searchTerm');
      }
      // push new state to allow back/forward across searches
      window.history.pushState({}, '', url.toString());
    } catch(e) {
        console.error('Error updating URL with search term:', e);
        }
  }

  // Apply search term from URL on page load (if present)
  function applyTermFromUrl(){
    try {
      const url = new URL(window.location.href);
      const q = url.searchParams.get('searchTerm');
      if (q) {
        input.value = q;
        
        // with htmx, submit the form to load results HTML; fallback to JSON search otherwise
        setTimeout(() => {
          if (window.htmx && form) {
            try { 
                window.htmx.trigger(form, 'submit'); 
            } 
            catch(e) { 
                console.error('Error triggering htmx submit:', e);
                form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); 
            }
          } 
        }, 100);
      }
    } catch(e) { 
        console.error('Error applying term from URL:', e); 
    }
  }

  // Update URL on form submit (HTMX path) so address bar always reflects latest search
  if (form) {
    form.addEventListener('submit', function(e){
      try {
        const term = (input && input.value || '').trim();
        updateUrlWithSearchTerm(term);
      } catch(e) {
          console.error('Error updating URL on form submit:', e);
      }
    }, true); // capture to run before HTMX request
  }

  window.addEventListener('popstate', function(){
    try {
      const url = new URL(window.location.href);
      const q = url.searchParams.get('searchTerm') || '';
      if (input) input.value = q;
      if (q) {
        if (window.htmx && form) {
          try { 
              window.htmx.trigger(form, 'submit'); 
          } catch(e) { 
              console.error('Error triggering htmx submit on popstate:', e); 
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); 
          }
        } 
      } else {
        // Clear results when no query
        if (list) list.innerHTML = '';
        if (empty) empty.style.display = 'none';
        if (count) count.textContent = '';
        clearMarkers();
        ensureMap();
      }
    } catch(e) { 
        console.error('Error handling popstate event:', e);
    }
  });

  // Google Maps loader: read key and map id from the page root data attributes
  const apiKey = (pageRoot && pageRoot.dataset && pageRoot.dataset.googleApiKey) || '';
  const mapId = (pageRoot && pageRoot.dataset && pageRoot.dataset.googleMapId) || 'DEMO_MAP_ID';

  function loadMaps(){
    return new Promise((resolve, reject) => {
      if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') { resolve(); return; }
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker`;
      script.async = true; 
      script.defer = true;
      script.onload = async function(){
        try {
          if (window.google && window.google.maps && typeof window.google.maps.importLibrary === 'function') {
            await window.google.maps.importLibrary('maps');
            await window.google.maps.importLibrary('marker');
          }
        } catch (e) {
          console.error('Error importing Google Maps libraries:', e);
        } finally {
          ensureMap();
          resolve();
        }
      };
      
      script.onerror = function(){ 
          const el = document.getElementById('map'); 
          if (el) el.style.display = 'none'; 
          if (mapNotice) mapNotice.style.display = 'block'; 
          console.error('Google Maps failed to load');
          reject(new Error('Google Maps failed to load')); 
      };
      
      document.head.appendChild(script);
    });
  }

    async function afterDomReady(){
        await loadMaps().catch((e) => {
            console.error('Error loading Google Maps:', e);
        }); 

        // When htmx swaps in results, parse embedded JSON to update map and count (no extra API call)
        document.body.addEventListener('htmx:afterSwap', function(evt){
          try {
            const targetEl = (evt && evt.detail && evt.detail.target) ? evt.detail.target : (evt ? evt.target : null);
            if (targetEl && targetEl.id === 'repResultsContainer') {
              const term = (input && input.value || '').trim();
              const container = document.getElementById('repResultsContainer');
              if (!container) return;
              const dataEl = container.querySelector('#repResultsData');
              if (!dataEl) return;
              let data = null;
              try { data = JSON.parse(dataEl.textContent || '{}'); } catch(e) {
                  console.error('Error parsing JSON:', e);
                  data = null; 
              }
              const repsArray = Array.isArray(data?.reps) ? data.reps : [];
              const reps = repsArray.map(r => {
                const name = r?.name || '';
                const lat = typeof r?.lat === 'number' ? r.lat : undefined;
                const lng = typeof r?.lng === 'number' ? r.lng : undefined;
                return { name, latLng: (typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)) ? { lat, lng } : null };
              });

              // update results count UI
              if (count) {
                count.textContent = '';
                const txt = `${reps.length} result${reps.length === 1 ? '' : 's'} for `;
                const prefix = document.createTextNode(txt + '"');
                const link = document.createElement('span');
                // enabling this code will cause the search term to be hyperlinked to recenter the map to the search results
                //const link = document.createElement('a');
                //link.href = '#';
                //link.id = 'recenterLink';
                link.className = 'recenter-link';
                link.textContent = term;
                const suffix = document.createTextNode('"');
                count.appendChild(prefix);
                count.appendChild(link);
                count.appendChild(suffix);
              }

              // update map markers
              let lat = (typeof data?.searchCenter?.lat === 'number') ? data.searchCenter.lat : undefined;
              let lng = (typeof data?.searchCenter?.lng === 'number') ? data.searchCenter.lng : undefined;

              if (!map && window.google) ensureMap(lat && lng ? { lat, lng } : undefined);
              if (map) {
                clearMarkers();
                const currentMarkers = [];
                if (typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)) {
                  const locMarker = addMarker(lat, lng, `Location: ${term}`, { useDefault: true });
                  if (locMarker) currentMarkers.push(locMarker);
                }
                reps.forEach((r) => {
                  if (r.latLng) {
                    const m = addMarker(r.latLng.lat, r.latLng.lng, r.name || 'Representative');
                    if (m) currentMarkers.push(m);
                  }
                });

                if (currentMarkers.length === 1) {
                  const p = getLatLngFromMarker(currentMarkers[0]);
                  if (p) { map.setCenter(p); map.setZoom(11); }
                } else if (currentMarkers.length > 1) {
                  const bounds = new google.maps.LatLngBounds();
                  currentMarkers.forEach(m => { const p = getLatLngFromMarker(m); if (p) bounds.extend(p); });
                  map.fitBounds(bounds);
                }

                const recenter = document.getElementById('recenterLink');
                if (recenter) {
                  recenter.addEventListener('click', function(e){ e.preventDefault(); if (infoWindow && typeof infoWindow.close === 'function') infoWindow.close(); recenterToAllMarkers(); });
                }
              }
            }
          } catch(e) {
              console.error('Error parsing embedded JSON:', e);
          }
        });
        // Apply query term from URL after DOM is ready
        applyTermFromUrl();
    }
      
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', afterDomReady);
    } else {
      afterDomReady();
    }
  }

  // Kick off setup after evaluating readiness
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}
